const inititalState = { role: null, isLogin: false };
const roleReducer = (state = inititalState, action) => {
  // eslint-disable-next-line default-case
  switch (action.type) {
    case "SETROLE": {
      return { ...state, role: action.payload };
    }
    case "SETLOGIN": {
      return { ...state, isLogin: action.payload };
    }
  }
  return state;
};
export default roleReducer;